import type { MetaFunction } from "react-router";
import Chat from "@/pages/Chat";
import Dashboard from "@/components/layout/Dashboard";

export const meta: MetaFunction = () => {
  return [
    { title: "Arcitext - AI-Assisted Writing" },
    {
      name: "description",
      content: "Start writing faster with Arcitext Chat. Your AI-powered writing coach and strategist.",
    },
    {
      tagName: "link",
      rel: "canonical",
      href: "https://www.arcitext.com",
    },
    {
      property: "og:title",
      content: "Chat - Arcitext",
    },
    {
      property: "og:description",
      content: "Start writing faster with Arcitext Chat. Your AI-powered writing coach and strategist.",
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "og:url",
      content: "https://www.arcitext.com",
    },
    {
      property: "og:image",
      content: "https://www.arcitext.com/og-image.png",
    },
  ];
};

// This route uses static pre-rendering
export default function Index() {
  return (
    <Dashboard>
      <Chat />
    </Dashboard>
  );
}
